import _ from 'lodash';
import { Action, combineReducers } from 'redux';
import { createTransform, persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import accountOwnerReducer, { leavesAccount } from 'src/store/account-owner/reducer';
import { RESET_STORE } from 'src/store/actions';
import cartReducer, { CartState } from 'src/store/cart/reducer';
import { commissionEntriesReducer, commissionStatsReducer } from 'src/store/comission-account/reducer';
import { createEntityActions } from 'src/store/entities/actions';
import entitiesReducers from 'src/store/entities/reducer';
import { EntityDescriptions } from 'src/store/entities/types';
import EntityDescription from 'src/store/entities/types/EntityDescription';
import { eventsReducer } from 'src/store/event/reducer';
import notificationReducer from 'src/store/notifications/reducer';
import shippingCostTableReducer from 'src/store/shipping-cost-table/reducer';
import {
    directCustomersReducer,
    successListEntryHistoryReducer,
    successListOverviewReducer,
    successListReducer,
    successListRegionsReducer,
    successListTopicsReducer,
} from 'src/store/success-list/reducer';
import {
    videoAdminReducer,
    videoCategoriesAdminReducer,
    videoCategoriesByTopicIdAdminReducer,
    videoRatingAdminReducer,
    videoTopicsAdminReducer,
} from 'src/store/video-admin/reducer';
import {
    nextVideoReducer,
    videoCategoriesReducer,
    videoLanguagesReducer,
    videoTopicsReducer,
} from 'src/store/video/reducer';
import landingpageReducer from 'src/store/welcome/reducer';
import {
    aboFilteredTemplatesReducer,
    aboSubscriptionOrderProductsReducer,
    aboTemplateReducer,
    aboTemplatesReducer,
} from './abo-templates/reducer';
import { addressConfirmationsReducer } from './address-confirmation/reducer';
import {
    adminCommissionInvoiceDetailsReducer,
    adminCommissionInvoiceFiltersReducer,
    adminCommissionInvoicesReducer,
} from './admin-commission-invoice/reducer';
import { landingpagesReducerAdmin } from './admin-landingPage/reducer';
import { adminOrderFiltersReducer, adminOrderProductDetailsReducer, adminOrdersReducer } from './admin-orders/reducer';
import { serviceComplaintsReducer } from './admin-service/reducer';
import { adyenConfirmReducerAdmin, adyenPreviewReducerAdmin, adyenReducerAdmin } from './adyen-batch/reducer';
import {
    articleArticleGroupReducer,
    articleGroupCountryTaxReducer,
    articleGroupRebateReducer,
} from './article-management/article-group/reducer';
import {
    articleArticleAssignmentReducer,
    articleArticleCustomFieldReducer,
    articleArticleImagesReducer,
    articleArticleProductGroupsReducer,
    articleArticlePropertyReducer,
    articleArticleReducer,
} from './article-management/article/reducer';
import { articleCommissionModelReducer } from './article-management/commission-model/reducer';
import { adminProductGroupsReducer } from './article-management/productgroup/reducer';
import { vendorArticlePricesReducer, vendorArticlesReducer } from './article-management/vendor-article/reducer';
import { confirmationsReducer } from './confirmations/reducer';
import { countriesReducer } from './country/reducer';
import { customerAddressReducer } from './customer/addresses/reducer';
import {
    customerDataReducer,
    customerFeedbackReducer,
    customerMailAddressReducer,
    customerPhoneNumberReducer,
} from './customer/data/reducer';
import { customerDocumentsReducer } from './customer/documents/reducer';
import {
    customerBillsInfoReducer,
    customerBillsReducer,
    customerCommissionBillsInfoReducer,
    customerCommissionBillsReducer,
    customerDownloadsReducer,
    customerDownloadTopicsReducer,
} from './customer/downloads/reducer';
import { customerMessagesReducer } from './customer/notes/reducer';
import { customerOrdersReducer } from './customer/orders/reducer';
import { partnerNoPayoutRationaleReducer } from './customer/partner-data/reducer';
import { customerPaymentMethodsAdminReducer, customerPaymentMethodsReducer } from './customer/paymentMethods/reducer';
import { customerAppliancesReducer, customerComplaintsReducer } from './customer/services/reducer';
import { downloadCategoriesReducer, downloadLanguageReducer, downloadReducer } from './download-admin/reducer';
import {
    eventCommissionModelReducer,
    eventLanguageCountryModelReducer,
    eventLocationsReducer,
    eventParticipantReducer,
    eventsAdminReducer,
    eventTypeReducer,
} from './event-admin/reducer';
import { expertiseReducer } from './expertise/reducer';
import { landingpagesReducer } from './landingpage/reducer';
import { mailPreviewReducer, mailTemplateReducer } from './mail-admin/reducer';
import {
    chipDetailReducer,
    chipHistoryReducer,
    chipMachinesReducer,
    chipMutationReducer,
    chipTransactionsReducer,
    chipYearlyReducer,
    customerMembershipsReducer,
    myChipsReducer,
    myMachinesReducer,
    myTransactionsReducer,
    myYearlyReducer,
    orgChipsReducer,
    orgMachinesReducer,
    orgMembersReducer,
    orgOverviewReducer,
    orgPersonsReducer,
    orgTransactionsReducer,
    orgYearlyReducer,
    productBillingReducer,
    settlementConfigReducer,
    settlementPartiesReducer,
    unmappedProductsReducer,
    vendingOrgsReducer,
} from './mitarbeiterchip/reducer';
import {
    mollieBatchConfirmReducerAdmin,
    mollieBatchReducerAdmin,
    mollieSettlementOrdersReducerAdmin,
} from './mollie-batch/reducer';
import { noPayoutRationalesReducer } from './no-payout-rationale/reducer';
import { myOffersReducer, offersReducer, parkedCartReducer } from './offer/reducer';
import { orderProductsReducer } from './order-products/reducer';
import { orderingNoteSubjectsReducer } from './ordering-note-subject/reducer';
import {
    organizationAppointmentsReducer,
    organizationContactsReducer,
    organizationCustomerAddressesReducer,
    organizationCustomerAppliancesReducer,
    organizationCustomerDataReducer,
    organizationCustomerEnablesReducer,
    organizationCustomerHistoryReducer,
    organizationCustomerLandingpagesReducer,
    organizationCustomerOrdersReducer,
    organizationCustomerReferralPartnerReducer,
    organizationCustomersReducer,
    organizationCustomerSubscriptionsReducer,
    organizationFavoritesReducer,
    organizationLeadUnlockReducer,
    organizationLicensorsReducer,
    organizationListCountsReducer,
    organizationOffersReducer,
    organizationOfficeProfisReducer,
    organizationOrdersReducer,
    organizationOverviewReducer,
    organizationPlacementsReducer,
    organizationRankingReducer,
    organizationSisPartnersReducer,
    organizationStatisticReducer,
    organizationTodoCountReducer,
    organizationTodosReducer,
    registeredEventsReducer,
    videoListReducer,
} from './organization/reducer';
import { paymentMethodAdminReducer } from './payment-method-admin/reducer';
import {
    paypalBatchFileDetailsReducerAdmin,
    paypalBatchReducerAdmin,
    paypalUnassignedOrdersReducerAdmin,
} from './paypal-batch/reducer';
import { productGroupReducer } from './product-groups/reducer';
import { productsReducer } from './products/reducer';
import { repairManagementReducer } from './repair-management/reducer';
import { repairOrdersReducer } from './repair-orders/reducer';
import { roleReducer } from './roles/reducer';
import {
    sepaBatchConfirmReducerAdmin,
    sepaBatchPreviewReducerAdmin,
    sepaBatchReducerAdmin,
} from './sepa-batch/reducer';
import { sepaDetailReducerAdmin, sepaReducerAdmin } from './sepa/reducer';
import {
    documentRegionsByTemplateKeyReducer,
    languageTemplateTranslationsReducer,
    marketingDocumentsReducer,
    templateAdminReducer,
    templateLanguageBlocksReducer,
    textBlockLanguagesReducer,
} from './templateAdmin/reducer';
import { usersReducer } from './users/reducer';

_.forEach(EntityDescriptions, (entityDescription: EntityDescription) => {
    createEntityActions(entityDescription);
});

// reducers
const appReducer = () =>
    combineReducers({
        addressConfirmation: addressConfirmationsReducer,
        entities: combineReducers(entitiesReducers()),
        customerMailAddresses: customerMailAddressReducer,
        customerPhoneNumbers: customerPhoneNumberReducer,
        customerAddresses: customerAddressReducer,
        customerPaymentMethods: customerPaymentMethodsReducer,
        customerAdminPaymentMethods: customerPaymentMethodsAdminReducer,
        customerData: customerDataReducer,
        customerMessages: customerMessagesReducer,
        customerDocuments: customerDocumentsReducer,
        customerOrders: customerOrdersReducer,
        customerAppliances: customerAppliancesReducer,
        customerComplaints: customerComplaintsReducer,
        customerDownloadTypes: customerDownloadTopicsReducer,
        customerDownloads: customerDownloadsReducer,
        customerBillsInfo: customerBillsInfoReducer,
        customerBills: customerBillsReducer,
        customerCommissionBillsInfo: customerCommissionBillsInfoReducer,
        customerCommissionBills: customerCommissionBillsReducer,
        customerFeedback: customerFeedbackReducer,
        adminProductGroups: adminProductGroupsReducer, // AdminPanel
        vendorArticles: vendorArticlesReducer, // AdminPanel
        vendorArticlePrices: vendorArticlePricesReducer, // AdminPanel
        articleArticle: articleArticleReducer, // AdminPanel
        articleArticleAssignment: articleArticleAssignmentReducer, // AdminPanel
        articleArticleImages: articleArticleImagesReducer, // AdminPanel
        articleCustomField: articleArticleCustomFieldReducer, // AdminPanel
        articleCommissionModels: articleCommissionModelReducer, // AdminPanel
        articleGroup: articleArticleGroupReducer, // AdminPanel
        articleGroupCountryTax: articleGroupCountryTaxReducer, // AdminPanel
        articleArticleProductGroup: articleArticleProductGroupsReducer, // AdminPanel
        groupRebates: articleGroupRebateReducer, // AdminPanel
        articleProperty: articleArticlePropertyReducer, // AdminPanel
        confirmations: confirmationsReducer, // AdminPanel
        countries: countriesReducer, // AdminPanel
        downloads: downloadReducer, // AdminPanel
        downloadCategories: downloadCategoriesReducer, // AdminPanel
        downloadLanguages: downloadLanguageReducer, // AdminPanel
        eventsAdmin: eventsAdminReducer, // AdminPanel
        eventCommissionAdmin: eventCommissionModelReducer, // AdminPanel
        eventLocationsAdmin: eventLocationsReducer, // AdminPanel
        eventLanguageCountry: eventLanguageCountryModelReducer, // AdminPanel
        eventParticipants: eventParticipantReducer, // AdminPanel
        eventType: eventTypeReducer, // AdminPanel
        expertises: expertiseReducer, // AdminPanel
        landingPagesAdmin: landingpagesReducerAdmin, // AdminPanel
        mail: mailTemplateReducer, // AdminPanel
        mailPreview: mailPreviewReducer, // AdminPanel
        orderProducts: orderProductsReducer, // AdminPanel
        offsettingOrders: adminOrdersReducer, // AdminPanel
        offsettingOrderFilters: adminOrderFiltersReducer, // AdminPanel
        offsettingOrderProductDetails: adminOrderProductDetailsReducer, // AdminPanel
        offsettingCommissionInvoices: adminCommissionInvoicesReducer, // AdminPanel
        offsettingCommissionInvoiceDetails: adminCommissionInvoiceDetailsReducer, // AdminPanel
        offsettingCommissionInvoiceFilters: adminCommissionInvoiceFiltersReducer, // AdminPanel
        offsettingAdyen: adyenReducerAdmin, // AdminPanel
        offsettingAdyenPreview: adyenPreviewReducerAdmin,
        offsettingAdyenConfirm: adyenConfirmReducerAdmin,
        offsettingSepa: sepaReducerAdmin, // AdminPanel
        offsettingSepaDetail: sepaDetailReducerAdmin, // AdminPanel
        offsettingMollieBatch: mollieBatchReducerAdmin, // AdminPanel
        offsettingMollieSettlementOrders: mollieSettlementOrdersReducerAdmin, // AdminPanel
        offsettingMollieBatchConfirm: mollieBatchConfirmReducerAdmin, // AdminPanel
        offsettingSepaBatch: sepaBatchReducerAdmin, // AdminPanel
        offsettingSepaBatchPreview: sepaBatchPreviewReducerAdmin, // AdminPanel
        offsettingSepaBatchConfirm: sepaBatchConfirmReducerAdmin, // AdminPanel
        paypalBatches: paypalBatchReducerAdmin, // AdminPanel
        paypalBatchFileDetails: paypalBatchFileDetailsReducerAdmin, // AdminPanel
        paypalPaypalUnassignedOrders: paypalUnassignedOrdersReducerAdmin, // AdminPanel
        paymentMethodsAdmin: paymentMethodAdminReducer, // AdminPanel
        products: productsReducer, // AdminPanel
        productGroups: productGroupReducer, // AdminPanel
        repairOrders: repairOrdersReducer, // AdminPanel
        repairManagement: repairManagementReducer, // AdminPanel
        roles: roleReducer, // AdminPanel
        serviceComplaints: serviceComplaintsReducer, // AdminPanel
        templateAdmin: templateAdminReducer, // AdminPanel
        users: usersReducer, // AdminPanel
        videoTopicsAdmin: videoTopicsAdminReducer, // AdminPanel
        videoRatingsAdmin: videoRatingAdminReducer, // AdminPanel
        videoCategoriesByTopicIdAdmin: videoCategoriesByTopicIdAdminReducer, // AdminPanel
        videoCategoriesAdmin: videoCategoriesAdminReducer, // AdminPanel
        video: videoAdminReducer, // AdminPanel
        notistack: notificationReducer,
        cart: cartReducer,
        accountOwner: accountOwnerReducer,
        videoTopics: videoTopicsReducer,
        videoCategories: videoCategoriesReducer,
        videoLanguages: videoLanguagesReducer,
        events: eventsReducer,
        shippingCostTable: shippingCostTableReducer,
        successListOverview: successListOverviewReducer,
        successListTopics: successListTopicsReducer,
        successListEntries: successListReducer,
        successListEntryHistory: successListEntryHistoryReducer,
        directCustomers: directCustomersReducer,
        successListRegions: successListRegionsReducer,
        commissionStats: commissionStatsReducer,
        commissionEntries: commissionEntriesReducer,
        organizationStatistic: organizationStatisticReducer,
        organizationLeadUnlock: organizationLeadUnlockReducer,
        organizationRanking: organizationRankingReducer,
        organizationAppointments: organizationAppointmentsReducer,
        organizationContacts: organizationContactsReducer,
        organizationOffers: organizationOffersReducer,
        organizationOrders: organizationOrdersReducer,
        organizationOverview: organizationOverviewReducer,
        organizationTodos: organizationTodosReducer,
        organizationTodoCount: organizationTodoCountReducer,
        organizationListCounts: organizationListCountsReducer,
        registeredEvents: registeredEventsReducer,
        organizationCustomerAppliances: organizationCustomerAppliancesReducer,
        videoList: videoListReducer,
        nextVideo: nextVideoReducer,
        organizationCustomerOrders: organizationCustomerOrdersReducer,
        organizationCustomerSubscriptions: organizationCustomerSubscriptionsReducer,
        organizationCustomerHistory: organizationCustomerHistoryReducer,
        organizationCustomerData: organizationCustomerDataReducer,
        organizationCustomerAddresses: organizationCustomerAddressesReducer,
        organizationCustomerLandingpages: organizationCustomerLandingpagesReducer,
        organizationCustomerReferralPartner: organizationCustomerReferralPartnerReducer,
        organizationCustomerEnables: organizationCustomerEnablesReducer,
        organizationCustomers: organizationCustomersReducer,
        organizationSisPartners: organizationSisPartnersReducer,
        organizationLicensors: organizationLicensorsReducer,
        organizationPlacements: organizationPlacementsReducer,
        organizationOfficeProfis: organizationOfficeProfisReducer,
        organizationFavorites: organizationFavoritesReducer,
        landingpage: landingpageReducer,
        landingpages: landingpagesReducer,
        myOffers: myOffersReducer,
        parkedCart: parkedCartReducer,
        offers: offersReducer,
        templateLanguageBlocks: templateLanguageBlocksReducer,
        languageBlockTranslations: languageTemplateTranslationsReducer,
        textBlockLanguages: textBlockLanguagesReducer,
        marketingDocuments: marketingDocumentsReducer,
        noPayoutRationales: noPayoutRationalesReducer,
        orderingNoteSubjects: orderingNoteSubjectsReducer,
        partnerNoPayoutRationales: partnerNoPayoutRationaleReducer,
        documentRegions: documentRegionsByTemplateKeyReducer,
        customerAboTemplates: aboTemplatesReducer,
        customerAboTemplate: aboTemplateReducer,
        customerAboFilteredTemplates: aboFilteredTemplatesReducer,
        aboSubscriptionOrderProducts: aboSubscriptionOrderProductsReducer,
        vendingOrgs: vendingOrgsReducer,
        myChips: myChipsReducer,
        customerMemberships: customerMembershipsReducer,
        orgMembers: orgMembersReducer,
        orgChips: orgChipsReducer,
        orgOverview: orgOverviewReducer,
        orgYearly: orgYearlyReducer,
        orgTransactions: orgTransactionsReducer,
        orgMachines: orgMachinesReducer,
        orgPersons: orgPersonsReducer,
        chipDetail: chipDetailReducer,
        chipTransactions: chipTransactionsReducer,
        chipHistory: chipHistoryReducer,
        chipYearly: chipYearlyReducer,
        chipMachines: chipMachinesReducer,
        myTransactions: myTransactionsReducer,
        myMachines: myMachinesReducer,
        myYearly: myYearlyReducer,
        chipMutation: chipMutationReducer,
        settlementConfig: settlementConfigReducer,
        settlementParties: settlementPartiesReducer,
        productBilling: productBillingReducer,
        unmappedProducts: unmappedProductsReducer,
    });

const rootReducer = () => (state: any, action: Action) => {
    if (action.type === RESET_STORE) return appReducer()({} as any, action);
    if (state && leavesAccount(state.accountOwner, action)) {
        return appReducer()({ notistack: state.notistack } as any, action);
    }

    return appReducer()(state, action);
};

// type of whole application state
export type AppState = ReturnType<typeof appReducer>;

export const REDUX_PERSIST_KEY = 'lamante';

/** Live-Runde 14 item 16: no cart calc survives a reload — a cart stored mid-calc must not wait for its answer. */
const settleCartOnRehydrate = createTransform(null, (stored: CartState) => ({ ...stored, isFetching: false }), {
    whitelist: ['cart'],
});

// persist redux storage
export const createPersistedRootReducer = () =>
    persistReducer(
        {
            key: REDUX_PERSIST_KEY,
            storage: storageSession,
            blacklist: ['notistack'],
            transforms: [settleCartOnRehydrate],
        },
        rootReducer()
    );
